// Names from https://material.io/resources/icons/?style=baseline

export const ICON_NAMES_IN_USE = [
  'account_circle',
  'add_circle',
  'done',
  'done_all',
  'add_circle_outline',
  'apartment',
  'arrow_back',
  'arrow_downward',
  'arrow_upward',
  'attach_file',
  'new_releases',
  'battery_full',
  'share',
  'add',
  'build',
  'charging_station',
  'cancel',
  'check_circle',
  'check_circle_outline',
  'close',
  'contact_support',
  'content_copy',
  'delete',
  'delete_forever',
  'delete_outline',
  'departure_board',
  'devices_other',
  'directions_car',
  'edit',
  'email',
  'error',
  'error_outline',
  'exit_to_app',
  'explore',
  'fiber_manual_record',
  'flag',
  'gps_fixed',
  'help',
  'help_center',
  'help_outline',
  'highlight_off',
  'home_work',
  'house',
  'import_export',
  'insert_drive_file',
  'keyboard_arrow_right',
  'list',
  'list_alt',
  'local_gas_station',
  'local_parking',
  'local_phone',
  'location_off',
  'location_on',
  'mail_outline',
  'map',
  'mastercard',
  'menu',
  'navigation',
  'near_me',
  'notifications',
  'pause',
  'people',
  'people_outline',
  'person',
  'print',
  'remove_circle',
  'request_quote',
  'score',
  'search',
  'search_off',
  'settings',
  'sms',
  'transfer_within_a_station',
  'visa',
  'vpn_key',
  'warning',
  'wifi',
  'wifi_off',
  'business_center',
  'pdf',
  'csv',
  'chat',
  'output',
  'send',
  'history_toggle',
  'amex',
  'cartes_bancaires',
  'diners_club',
  'discover',
  'jcb',
  'mastercard',
  'videocam',
  'visa',
  'unionpay',
  '360',
  'refresh',
  'crown',
  'info',
  'remove',
  'solbox_icon',
  'logmaster_icon',
  'linxiovision_icon',
  'terms_of_use',
  'privacy_policy',
  'thermostat',
  'water_drop_half',
  'head_light_mode',
  'local_gas_station_stroke',
  'instant_fuel',
  'gas_percent',
  'air_input',
  'air_pressure',
  'coolant_temp',
  'engine_load',
  'throttle_position',
]
